import { formatFullNumber } from "./formatNumber";
import moment from "moment";

export function formatCustomMetric(value: any, formatType: string) {
    if (formatType === 'number') {
        return formatFullNumber(value);    
    }

    if (formatType === 'percentage') {
        if (value === undefined || value === null || isNaN(value)) {
            return;
        }

        value = Math.round(value);

        return value + '%';
    }

    if (formatType.startsWith('time')) {
        const match = formatType.match(/\((\d+:\d{2})\)/);
        const format = match ? match[1] : 'm:ss';

        return moment.utc(value * 1000).format(format);
    }

    return formatFullNumber(value);
}

export default formatCustomMetric;
